/** Standard sheet-range chips (customer surfaces). */
export const STD_RANGES = ['≤5', '6–10', '11–20', '21–40', '41–60', '61–100', '100+'];
export const STD_UPPER = [5, 10, 20, 40, 60, 100, Infinity];

export const fmtDays = d => {
  if (d == null) return 'Quote';
  return d === 1 ? '1 business day' : `${d} business days`;
};

export const fmtShort = d => {
  if (d == null) return 'Quote';
  return d === 1 ? '1 day' : `${d} days`;
};

export const isoDate = (d = new Date()) => {
  const x = d instanceof Date ? d : new Date(d);
  return `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, '0')}-${String(x.getDate()).padStart(2, '0')}`;
};

/** Card version in force on a date: latest appliesFrom on or before iso (A7). */
export const versionOn = (card, iso = isoDate()) => {
  const versions = card?.versions || [];
  if (!versions.length) return null;
  const eligible = versions.filter(v => (v.appliesFrom || '') <= iso);
  const list = eligible.length ? eligible : versions;
  return [...list].sort((a, b) => (a.appliesFrom < b.appliesFrom ? 1 : -1))[0];
};

export const daysAt = (card, rangeIdx, { iso = isoDate(), side = 'customer' } = {}) => {
  if (rangeIdx == null || !card) return null;
  const ver = versionOn(card, iso);
  if (!ver) return null;
  const row = side === 'internal' ? ver.internal : ver.customer;
  if (!row || rangeIdx < 0 || rangeIdx >= row.length) return null;
  return row[rangeIdx];
};

/**
 * Map a standard typical-range index onto a trade's own columns (B5).
 * Returns the trade column whose upper bound contains the standard upper bound.
 */
export const rangeIndexForTrade = (cfg, stdIdx) => {
  if (!cfg || stdIdx == null) return null;
  const ub = STD_UPPER[stdIdx];
  if (ub == null) return null;
  const upper = cfg.upper || STD_UPPER;
  let k = upper.findIndex(u => u >= ub);
  if (k < 0) k = upper.length - 1;
  return k;
};

/** Reverse: which STD index maps to a trade column (for clickable cells). */
export const stdIndexForTradeColumn = (cfg, colIdx) => {
  if (!cfg || colIdx == null) return null;
  for (let j = 0; j < STD_UPPER.length; j += 1) {
    if (rangeIndexForTrade(cfg, j) === colIdx) return j;
  }
  return null;
};
